export default {
  SSS_PATHNAME: ['cf-api-auth', 'cf/authentication', 'cf-api-sss']
};